import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

const top10 = [...comics].sort((a, b) => b.rating - a.rating).slice(0, 10);

export default function PopularRanking() {
  return (
    <section className="w-full py-10 md:py-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            热门排行
          </h2>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer whitespace-nowrap transition-colors"
          >
            查看全部
            <i className="ri-arrow-right-s-line text-lg"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {top10.map((comic, idx) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="flex items-center gap-4 p-3 rounded-lg bg-background-50 hover:bg-background-200 transition-colors cursor-pointer group"
            >
              <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center">
                <span
                  className={`text-lg font-heading font-bold ${
                    idx < 3 ? 'text-accent-500' : 'text-foreground-400'
                  }`}
                >
                  {idx + 1}
                </span>
              </div>
              <div className="w-12 h-16 flex-shrink-0 rounded overflow-hidden bg-background-200">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top"
                  title={`${comic.title} - 热门韩国漫画排行`}
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">
                  {comic.author}
                </p>
              </div>
              <div className="flex-shrink-0 flex flex-col items-end gap-1">
                <span className="flex items-center gap-1 text-xs text-foreground-600">
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  {comic.rating}
                </span>
                <span className="text-xs text-foreground-400">
                  {comic.chapters}话
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}